import * as React from "react";
import { Typography, Card, CardContent, CardActionArea, Paper, Box } from '@mui/material';

const CaseStudyCard = props => {
	const { caseStudy, isTall } = props;
	const { title, headerImage: backgroundImage, uri, Industry } = caseStudy;
	let industry = Array.isArray(Industry) ? Industry[0]?.object : Industry.object;
	let name = industry?.name;
	if (!industry) name = "";

	const cardWrapStyle = {
		height: "100%",
		borderRadius: "0",
	}

	const cardActionStyle = {
		position: 'relative',
		padding: "25px 21px",
		maxHeight: "361px",
		minHeight: "219px",
		backgroundImage: `url(${process.env.CDN_DOMAIN||''}${backgroundImage})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		height: '100%',
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'flex-end',
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.5)',
		},
		'&::after': {
			background: "linear-gradient(0deg, rgba(15, 35, 69, 0.8) 53%, rgba(6, 18, 33, 0) 100%)",
			content: '""',
			position: 'absolute',
			left: 0,
			bottom: 0,
			width: "100%",
			height: "147px",
		},
		...(isTall ? {
			minHeight: "361px",
		} : {})
	};

	const cardContentStyle = {
		padding: 0,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
		alignItems: 'flex-start',
		height: '100%',

		position: 'relative',
		zIndex: 2,
	}

	const titleStyle = {
		textShadow: "0px 4px 4px #000",
		fontSize: "20px",
		fontWeight: 600,
		lineHeight: 1,
		marginBottom: "13px",
	}

	return (
		<Card sx={cardWrapStyle} variant="caseStudyCard">
			<CardActionArea sx={cardActionStyle} href={uri} disableRipple={true}>
				<CardContent sx={cardContentStyle}>
					<Typography sx={titleStyle} component='h3'>{title}</Typography>
					{name && <Paper className={`label__chip ghost`} variant="label">
						<Box component="span" className="topic__chip__label">{name}</Box>
					</Paper>}
				</CardContent>
			</CardActionArea>
		</Card>
	)
};


export default CaseStudyCard;